

































































































































































import Vue from "vue";
import { Task, TaskGroup } from "@/tasks";
import Utils from "@/utils";
import TasksList from "../tasks/TasksList.vue";
import { TaskFilterOption, TaskSortOption } from "@/enums";
import TaskFilter from "../tasks/TasksFilter.vue";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import TeamTask from "@/views/Teams/TeamTask.vue";
import { Member } from "@/teams";
import * as UserApplicationState from "@/userapplicationstate";
import { Constants } from "@/constants";

export default Vue.extend({
    name: "TasksTab",
    components: { TasksList, TaskFilter, ZenyaDialog, TeamTask },
    props: {
        tasks: Array as () => Task[],
        isBusy: Boolean,
        teamID: String,
        teamMembers: Array as () => Member[],
        filter: String as () => TaskFilterOption
    },
    data: () => {
        return {
            search: "",
            sort: TaskSortOption.DateNewToOld,
            taskFilterDrawer: false,
            filteredTasks: [] as Task[],
            selectedFilter: TaskFilterOption.My,
            taskgroups: [] as TaskGroup[],
            currentPortalId: 0,
            showAddTeamTaskDialog: false,
            bus: new Vue()
        };
    },
    async created() {
        if (this.mode == "user") document.title = Utils.getPageTitle(`${this.$t("portal.buttons.myTasks")}`, "before");
        this.sort = await this.getSortOption();
        this.setFilterOption();
        //Save tasks as last tab
        sessionStorage.setItem(Constants.Task.ApplicationsState.TasksLastTab, "tasks");
        //Set filter options from state only when there is no filter passed as prop (from query string)
        if (!this.filter) {
            //Set filter from state
            const taskFilterOptionState: string | null = await UserApplicationState.get(Constants.Task.ApplicationsState.TaskFilterOption);
            if (taskFilterOptionState) this.selectedFilter = taskFilterOptionState as TaskFilterOption;

            //Set filter group from state
            const taskFilterGroupOptionState: string | null = await UserApplicationState.get(Constants.Task.ApplicationsState.TaskFilterGroupOption);
            if (taskFilterGroupOptionState) this.taskgroups = JSON.parse(taskFilterGroupOptionState) as TaskGroup[];
        }
    },
    updated() {
        //Make sure we set on scroll event everytime when updated is called
        this.bus?.$emit("set-on-scroll-event");
    },
    computed: {
        mode(): "user" | "team" {
            return this.teamID ? "team" : "user";
        },
        mdAndDownView(): boolean {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        sortOptions(): string[] {
            const options: Array<string> = [
                TaskSortOption.DateNewToOld,
                TaskSortOption.DateOldToNew,
                TaskSortOption.Deadline,
                TaskSortOption.Important
            ];
            return options;
        },
        hasTasks(): boolean {
            return this.tasks.length > 0;
        },
        filteredAndSortedTasks(): Task[] {
            const sorted = [...this.filteredTasks];

            if (this.sort == TaskSortOption.Deadline) {
                sorted.sort((a, b) => {
                    const sortValueA = parseFloat(`${a.deadline_date_time ? a.deadline_date_time.getTime() : 0}.${a.created_date_time}`);
                    const sortValueB = parseFloat(`${b.deadline_date_time ? b.deadline_date_time.getTime() : 0}.${b.created_date_time}`);
                    return sortValueB - sortValueA;
                });
            } else if (this.sort == TaskSortOption.DateNewToOld) {
                sorted.sort((a, b) => {
                    const sortValueA = parseFloat(`${a.created_date_time.getTime()}.${a.last_modified_date_time.getTime()}`);
                    const sortValueB = parseFloat(`${b.created_date_time.getTime()}.${b.last_modified_date_time.getTime()}`);
                    return sortValueB - sortValueA;
                });
            } else if (this.sort == TaskSortOption.DateOldToNew) {
                sorted.sort((a, b) => {
                    const sortValueA = parseFloat(`${a.created_date_time.getTime()}.${a.last_modified_date_time.getTime()}`);
                    const sortValueB = parseFloat(`${b.created_date_time.getTime()}.${b.last_modified_date_time.getTime()}`);
                    return sortValueA - sortValueB;
                });
            } else if (this.sort == TaskSortOption.Important) {
                sorted.sort((a, b) => {
                    const sortValueA = parseFloat(`${a.is_important ? 2 : 1}.${a.last_modified_date_time.getTime()}`);
                    const sortValueB = parseFloat(`${b.is_important ? 2 : 1}.${b.last_modified_date_time.getTime()}`);
                    return sortValueB - sortValueA;
                });
            }
            UserApplicationState.set(Constants.Task.ApplicationsState.TaskSort, this.sort);
            return sorted;
        }
    },
    watch: {
        filter() {
            this.setFilterOption();
        },
        tasks: {
            deep: true,
            handler(): void {
                if (!this.tasks || this.tasks.length == 0) this.filteredTasks = [];
            }
        }
    },
    methods: {
        setFilterOption(): void {
            if (this.filter) {
                //Set filter from query string
                if (this.filter == TaskFilterOption.My || this.filter == TaskFilterOption.NotAssigned || this.filter == TaskFilterOption.Postponed)
                    this.selectedFilter = this.filter;

                //Remove the filter query string
                if (this.$route.query.filter) this.$router.replace({ query: null });
            }
        },
        async getSortOption(): Promise<TaskSortOption> {
            const sortOption = await UserApplicationState.get(Constants.Task.ApplicationsState.TaskSort);
            return sortOption ? (sortOption as TaskSortOption) : TaskSortOption.DateNewToOld;
        },
        filterChanged(filter: string): void {
            UserApplicationState.set(Constants.Task.ApplicationsState.TaskFilterOption, filter);
            UserApplicationState.remove(Constants.Task.ApplicationsState.TaskFilterGroupOption);
        },
        filterGroupChanged(filterGroup: string[]): void {
            if (filterGroup.length == 0) UserApplicationState.remove(Constants.Task.ApplicationsState.TaskFilterGroupOption);
            else UserApplicationState.set(Constants.Task.ApplicationsState.TaskFilterGroupOption, JSON.stringify(filterGroup));
        }
    }
});
